<template>
  <popup
    :opened="dataToShow"
    @close="changeToShow(false)"
  >
    <message-header :message-header="messageHeader" />

    <div class="sticky top-0 z-10">
      <!-- Save button -->
      <div
        v-if="saving"
        class="absolute w-14 h-14 right-1 mt-13 mr-13 rounded-full cursor-pointer bg-pink-600 hover:shadow-pink text-white"
      >
        <span class="h-6 w-6 ml-4 mt-1/4 spinner spinner-save" />
      </div>
      <div
        v-else
        class="absolute w-14 h-14 right-1 mt-13 mr-13 rounded-full cursor-pointer bg-pink-600 hover:shadow-pink text-white"
        @click="saveSpecificRights"
      >
        <icon
          name="save"
          class="h-6 w-6 ml-4 mt-1/4"
        />
      </div>
    </div>

    <!-- BEGIN Content modal specific rights for a referent -->
    <div class="w-full mt-10 mb-10">
      <h3 class="w-full my-5 lg:my-15 2xl:my-20">
        Ajouter des droits d'accès <br>spécifiques
      </h3>

      <div
        class="w-full text-left text-pink-600 text-lg mb-10 mx-5 lg:mx-15 2xl:mx-20"
      >
        DROITS ET RESTRICTIONS
      </div>

      <div class="grid grid-cols-2 mx-5 lg:mx-15 2xl:mx-20">
        <div class="col-span-full sm:col-span-1">
          <div
            v-if="
              listNeopassModulesPages.filter((m) =>
                permissions.includes(m.name + '_read')
              ).length > 0
            "
          >
            <checkbox-indigo
              name="Lecture"
              libelle="LECTURE"
              color-libelle="indigo-600"
              :value="
                (((specificRightsToEdit || {}).neopassForm || {}).read || {})
                  .all
              "
              @input="
                (newValue) => {
                  (
                    ((specificRightsToEdit || {}).neopassForm || {}).read || {}
                  ).all = newValue;
                  checkall('read', 'all', newValue);

                  if (!newValue) {
                    (
                      ((specificRightsToEdit || {}).neopassForm || {}).edit ||
                      {}
                    ).all = newValue;
                    checkall('edit', 'all', newValue);
                  }
                }
              "
              class="text-indigo-600"
              size-libelle="text-base"
            />
          </div>
          <div
            v-for="(mod, numMod) in listNeopassModulesPages.filter((m) =>
              permissions.includes(m.name + '_read')
            )"
            :key="numMod"
            class="m-3"
          >
            <div>
              <checkbox-indigo
                :name="mod.name"
                :libelle="mod.display_name"
                :value="
                  (
                    (((specificRightsToEdit || {}).neopassForm || {}).read ||
                      {})[mod.name] || {}
                  ).all
                "
                @input="
                  (newValue) => {
                    (
                      (((specificRightsToEdit || {}).neopassForm || {}).read ||
                        {})[mod.name] || {}
                    ).all = newValue;
                    checkall('read', mod.name, newValue);
                    decheckall('read', mod.name, newValue);

                    if (!newValue) {
                      (
                        (((specificRightsToEdit || {}).neopassForm || {})
                          .edit || {})[mod.name] || {}
                      ).all = newValue;
                      checkall('edit', mod.name, newValue);
                      decheckall('edit', mod.name, newValue);
                    }
                  }
                "
                class="mb-1.5"
                size-libelle="text-base"
              />
            </div>

            <div
              v-for="(page, numPage) in mod.pages.filter(
                (p) =>
                  permissions.includes(p.name + '_read') &&
                  p.name != constants.PAGE_NEOPASS_FORM_DOCUMENTS
              )"
              :key="numPage"
            >
              <checkbox-indigo
                :name="page.name"
                :libelle="page.display_name"
                :value="
                  ((((specificRightsToEdit || {}).neopassForm || {}).read ||
                    {})[mod.name] || {})[page.name]
                "
                @input="
                  (newValue) => {
                    ((((specificRightsToEdit || {}).neopassForm || {}).read ||
                      {})[mod.name] || {})[page.name] = newValue;
                    decheckall('read', mod.name, newValue);

                    if (!newValue) {
                      ((((specificRightsToEdit || {}).neopassForm || {}).edit ||
                        {})[mod.name] || {})[page.name] = newValue;
                      decheckall('edit', mod.name, newValue);
                    }
                  }
                "
                color-libelle="text-gray-600"
                size-libelle="text-base"
                weight-libelle="font-light"
              />
            </div>
            <checkbox-indigo
              v-if="permissions.includes(mod.name + '_auto_eval_read')"
              :name="mod.name + '_auto_eval_read'"
              libelle="Auto Evaluation Bénéficiaire"
              color-libelle="gray-600"
              :value="
                ((((specificRightsToEdit || {}).neopassForm || {}).read || {})[
                  mod.name
                ] || {})['auto_eval']
              "
              @input="
                (newValue) => {
                  ((((specificRightsToEdit || {}).neopassForm || {}).read ||
                    {})[mod.name] || {})['auto_eval'] = newValue;
                  decheckall('read', mod.name, newValue);
                  if (!newValue) {
                    ((((specificRightsToEdit || {}).neopassForm || {}).edit ||
                      {})[mod.name] || {})['auto_eval'] = newValue;
                    decheckall('edit', mod.name, newValue);
                  }
                }
              "
              class="text-gray-600"
              size-libelle="text-base"
              weight-libelle="font-light"
            />
          </div>
        </div>
        <div class="col-span-full sm:col-span-1">
          <div
            v-if="
              listNeopassModulesPages.filter((m) =>
                permissions.includes(m.name + '_edit')
              ).length > 0
            "
          >
            <checkbox-indigo
              name="Ecriture"
              libelle="ECRITURE"
              :value="
                (((specificRightsToEdit || {}).neopassForm || {}).edit || {})
                  .all
              "
              @input="
                (newValue) => {
                  (
                    ((specificRightsToEdit || {}).neopassForm || {}).edit || {}
                  ).all = newValue;
                  checkall('edit', 'all', newValue);

                  if (newValue) {
                    (
                      ((specificRightsToEdit || {}).neopassForm || {}).read ||
                      {}
                    ).all = newValue;
                    checkall('read', 'all', newValue);
                  }
                }
              "
              color-libelle="text-indigo-600"
              size-libelle="text-base"
            />
          </div>
          <div
            v-for="(mod, numMod) in listNeopassModulesPages.filter((m) =>
              permissions.includes(m.name + '_edit')
            )"
            :key="numMod"
            class="m-3"
          >
            <div>
              <checkbox-indigo
                :name="mod.name"
                :libelle="mod.display_name"
                :value="
                  (
                    (((specificRightsToEdit || {}).neopassForm || {}).edit ||
                      {})[mod.name] || {}
                  ).all
                "
                @input="
                  (newValue) => {
                    (
                      (((specificRightsToEdit || {}).neopassForm || {}).edit ||
                        {})[mod.name] || {}
                    ).all = newValue;
                    checkall('edit', mod.name, newValue);
                    decheckall('edit', mod.name, newValue);

                    if (newValue) {
                      (
                        (((specificRightsToEdit || {}).neopassForm || {})
                          .read || {})[mod.name] || {}
                      ).all = newValue;
                      checkall('read', mod.name, newValue);
                    }
                  }
                "
                class="mb-1.5"
                size-libelle="text-base"
              />
            </div>
            <div
              v-for="(page, numPage) in mod.pages.filter(
                (p) =>
                  permissions.includes(p.name + '_edit') &&
                  p.name != constants.PAGE_NEOPASS_FORM_DOCUMENTS
              )"
              :key="numPage"
            >
              <checkbox-indigo
                :name="page.name"
                :libelle="page.display_name"
                :value="
                  ((((specificRightsToEdit || {}).neopassForm || {}).edit ||
                    {})[mod.name] || {})[page.name]
                "
                @input="
                  (newValue) => {
                    ((((specificRightsToEdit || {}).neopassForm || {}).edit ||
                      {})[mod.name] || {})[page.name] = newValue;
                    decheckall('edit', mod.name, newValue);

                    if (newValue) {
                      ((((specificRightsToEdit || {}).neopassForm || {}).read ||
                        {})[mod.name] || {})[page.name] = newValue;
                    }
                  }
                "
                color-libelle="text-gray-600"
                size-libelle="text-base"
                weight-libelle="font-light"
              />
            </div>
            <checkbox-indigo
              v-if="permissions.includes(mod.name + '_auto_eval_edit')"
              :name="mod.name + '_auto_eval_edit'"
              libelle="Auto Evaluation Bénéficiaire"
              color-libelle="gray-600"
              :value="
                ((((specificRightsToEdit || {}).neopassForm || {}).edit || {})[
                  mod.name
                ] || {})['auto_eval']
              "
              @input="
                (newValue) => {
                  ((((specificRightsToEdit || {}).neopassForm || {}).edit ||
                    {})[mod.name] || {})['auto_eval'] = newValue;
                  decheckall('edit', mod.name, newValue);
                  if (newValue) {
                    ((((specificRightsToEdit || {}).neopassForm || {}).read ||
                      {})[mod.name] || {})['auto_eval'] = newValue;
                  }
                }
              "
              class="text-gray-600"
              size-libelle="text-base"
              weight-libelle="font-light"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- END Content modal specific rights for a referent -->
  </popup>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import Popup from './../../../components/Popup';
import MessageHeader from './../../../components/MessageHeader';
import Icon from './../../../components/Icon';
import CheckboxIndigo from './../../../components/Inputs/CheckboxIndigo';

import Constants from './../../../constants';

export default {
  name: 'EditSpecificRightsPopup',

  props: {
    dataToShow: Boolean,
  },

  data() {
    return {
      constants: Constants,
    };
  },

  components: {
    Popup,
    MessageHeader,
    Icon,
    CheckboxIndigo,
  },

  computed: {
    ...mapGetters({
      saving: 'permissions/saving',
      messageHeader: 'permissions/messageHeader',
      errors: 'permissions/errors',
      listNeopassModulesPages: 'permissions/listNeopassModulesPages',
      specificRightsToEdit: 'beneficiariesReferent/specificRightsToEdit',
      permissions: 'auth/permissions',
    }),
  },

  methods: {
    ...mapActions({
      saveSpecificRights: 'beneficiariesReferent/saveSpecificRights',
    }),

    ...mapMutations({
      SET_ERRORS: 'permissions/SET_ERRORS',
    }),

    changeToShow(val) {
      this.$emit('showChange', val);
      this.SET_ERRORS(null);
    },

    checkall(readOrEdit, moduleName, state) {
      if (moduleName == 'all') {
        //console.log("checkall / readOrEdit = "+readOrEdit+" / mod = "+moduleName+" /state ", state);
        for (let mod in this.specificRightsToEdit.neopassForm[readOrEdit]) {
          if (mod != 'all') {
            for (var page in this.specificRightsToEdit.neopassForm[readOrEdit][
              mod
            ]) {
              this.specificRightsToEdit.neopassForm[readOrEdit][mod][page] =
                state;
            }

            // right for evaluation auto
            if (this.permissions.includes(mod + '_auto_eval_' + readOrEdit)) {
              this.specificRightsToEdit.neopassForm[readOrEdit][mod][
                'auto_eval'
              ] = state;
            }
          }
        }
      } else {
        //console.log("checkall / readOrEdit = "+readOrEdit+" / mod = "+moduleName+" /state ", state);
        for (var page in this.specificRightsToEdit.neopassForm[readOrEdit][
          moduleName
        ]) {
          if (page != 'all') {
            this.specificRightsToEdit.neopassForm[readOrEdit][moduleName][
              page
            ] = state;
          }
        }

        // right for evaluation auto
        if (
          this.permissions.includes(moduleName + '_auto_eval_' + readOrEdit)
        ) {
          this.specificRightsToEdit.neopassForm[readOrEdit][moduleName][
            'auto_eval'
          ] = state;
        }
      }
    },

    decheckall(readOrEdit, moduleName, state) {
      //console.log("decheckall / readOrEdit = "+readOrEdit+" / mod = "+moduleName+" / page = "+page+" /state ", state);
      if (this.specificRightsToEdit.neopassForm[readOrEdit].all) {
        this.specificRightsToEdit.neopassForm[readOrEdit].all = state;
      }

      if (this.specificRightsToEdit.neopassForm[readOrEdit][moduleName].all) {
        this.specificRightsToEdit.neopassForm[readOrEdit][moduleName].all =
          state;
      }
    },
  },
};
</script>
